/**
 * Font chữ
 */
export default {
  TimesNewRoman: 'Times New Roman',
  OpenSan: 'Open Sans',
  Arial: 'Arial',
  Tahoma: 'Tahoma',
  Cambria: 'Cambria',
  ArialNarrow: 'Arial Narrow',
};
